import {
  useDropdown 
} from "@/common/hooks/useDropdown"
import {
  useWindowSize 
} from "@/common/hooks/useWindowSize"
import mobileDeviceScreenWidth from "@/constants/mobileDeviceScreenWidth"
import {
  useUserContext 
} from "@/context/user"
import {
  useRouter 
} from "next/navigation"
import {
  useCallback 
} from "react"

export const useAccountTrigger = () => {
  const {
    elementRef: accountDropMenuRef,
    expanded: accountDropMenuIsOpen,
    setExpanded: setAccountDropMenuIsOpen,
    triggerRef: accountDropMenuTriggerRef,
  } = useDropdown()

  const router = useRouter()

  const [{
    isSignedIn: isUserSignedIn 
  }] = useUserContext()

  const isMobile = useWindowSize().innerWidth < mobileDeviceScreenWidth

  const handleTriggerClick = useCallback(() => {
    if (isUserSignedIn) {
      const link = isMobile ? "/personal-center-mobile" : "/order-history"

      router.push(link)
    } else {
      router.push("/sign-in")
    }
  }, [isUserSignedIn, isMobile, router])

  return {
    accountDropMenuIsOpen,
    accountDropMenuRef,
    accountDropMenuTriggerRef,
    setAccountDropMenuIsOpen,
    handleTriggerClick,
    isUserSignedIn,
  }
}
